'use strict';
(function ($) {
    var $orderLookupForm = $('.jwsdw-orderLookup-form'),
        $formButton = $('.jwsdw-orderLookup-submit'),
        $formButtonText = $formButton.find('.jwsdw-buttonText'),
        $formButtonSpinner = $formButton.find('.jwsdw-spinner'),
        $orderLookupError = $('.jwsdw-orderLookup-error');

    $.validator.setDefaults({
        'rules': {
            'email': {
                'invalidvalue': true,
                'customemail': true
            }
        }
    });

    // initialize form validation
    $orderLookupForm.validate();

    /* Order lookup form handling */

    /**
     * @description Helper function to verify whether an order exists.
     * @param {jQuery} $form - The submitted form.
     * @returns {Promise} a promise which resolves with the server response.
     */
    function verifyOrder($form) {
        return new Promise((resolve, reject) => {
            $.ajax({
                'url': $form.data('prevalidation'),
                'method': 'GET',
                'data': $form.serialize(),
                'success': resolve,
                'error': (error) => reject(error.responseJSON && error.responseJSON.code)
            });
        });
    }

    /**
     * @description Function used to handle order lookup form submission.
     * @param {SubmitEvent} e - The order lookup form's submit event.
     * @returns {undefined}
     */
    function handleOrderLookup(e) {
        e.preventDefault();

        const $form = $(this),
            $captcha = $form.find('.g-recaptcha');

        /**
         * @description Function used to verify whether the order belongs to the current customer and submit the form.
         * @returns {undefined}
         */
        function submitForm() {
            $orderLookupError.addClass('jws-hidden');
            $formButtonText.addClass('jwsdw-invisible');
            $formButtonSpinner.removeClass('jws-hidden');
            $formButton.attr('disabled', 'disabled');
            verifyOrder($form)
                .then(() => {
                    if (window.jwsdwRecaptchaSettings.captchaDisabled === false) {
                        window.grecaptcha.ready(function() {
                            window.jwsdwUtil.captcha.execute($captcha.attr('id'), 'orderLookup').then(() => $form.off('submit').trigger('submit'));
                        });
                    } else {
                        $form.off('submit').trigger('submit');
                    }
                })
                .catch((errorCode) => {
                    $formButtonText.removeClass('jwsdw-invisible');
                    $formButtonSpinner.addClass('jws-hidden');
                    $formButton.removeAttr('disabled');

                    if (errorCode === 'ORDER_NOT_FOUND') {
                        $orderLookupError.removeClass('jws-hidden');
                    }
                });
        }

        if ($form.valid()) {
            if (window.jwsdwRecaptchaSettings.captchaDisabled === false) {
                window.grecaptcha.ready(function() {
                    window.jwsdwUtil.captcha.execute($captcha.attr('id'), 'orderLookup').then(submitForm);
                });
            } else {
                submitForm();
            }
        }
    }

    $orderLookupForm.on('submit', handleOrderLookup);
}(jQuery));
